import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { colorTokens } from '../../app/designTokens';
import { RegisterSectionCard } from './RegisterSectionCard';

const { semantic } = colorTokens;

function lineColor(level) {
  if (level === 'error') {
    return semantic.error;
  }
  if (level === 'success') {
    return semantic.success;
  }
  return semantic.text.secondary;
}

/**
 * Step 5 — user-safe provisioning log. Lines are built from public launch status
 * flags only; raw backend logs, hosts and credentials are never rendered here.
 */
export function SafeProvisioningLog({ lines, testId = 'register-launch-live-logs' }) {
  const { t } = useTranslation(['onboarding']);

  return (
    <RegisterSectionCard
      title={t('onboarding:register.wizard.live_logs')}
      helper={t('onboarding:register.wizard.live_logs_helper')}
      testId={testId}
    >
      {lines.length === 0 ? (
        <Typography sx={{ fontSize: 13, color: semantic.text.muted }}>
          {t('onboarding:register.wizard.live_logs_empty')}
        </Typography>
      ) : (
        <Stack spacing={0.75} component="ul" sx={{ m: 0, pl: 2 }}>
          {lines.map((line) => (
            <Typography
              component="li"
              key={line.id}
              data-testid={`register-live-log-${line.id}`}
              data-level={line.level}
              sx={{ fontSize: 13, color: lineColor(line.level) }}
            >
              {line.text}
            </Typography>
          ))}
        </Stack>
      )}
    </RegisterSectionCard>
  );
}

export default SafeProvisioningLog;
